import $ from 'jquery';

import title from './title/title'
import filter from './filter/filter'

export default function(o,p,data,updateTitles){

  if(data.auth && !_.includes(data.auth, o.store('role'))){
    return null
  }

  var titleDiv = title(o,p,data,updateTitles)
  var filterDiv = filter(o,p,data)

  var div =
    $('<div>')
    .css({
      display: 'table-cell',
      width: '50px',
      borderRight: '1px solid rgba(255,255,255,0.1)',
    })
    .append(
      titleDiv,
      filterDiv,
    )

  div.updateTitle = titleDiv.update

  return div;

}



// WEBPACK FOOTER //
// ./src/client/view/admin/search/table/header/column/column.js